<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title
      ><span style="text-wrap: nowrap">{{ title }}</span></template
    >
    <v-container>
      <h4 class="title">{{ subTitle }}</h4>
    </v-container>
    <item-remarks v-model="remarks" :service-type="serviceType" />
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="!isValid"
        @click="onSave"
        v-if="!readOnly"
        >Save Remarks</v-btn
      >
    </template>
    <div v-if="debug">
      <code>{{ remarks }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
import ItemRemarks from "./ItemRemarks.vue";

export default {
  name: "remarks-edit-dialog",

  components: {
    BasicDialog,
    ItemRemarks,
  },

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    // serviceType: {
    //   type: String,
    //   required: true,
    // },
  },

  data() {
    return {
      debug: false,
      remarks: this.value ? { ...this.value.remarks } : null,
    };
  },

  computed: {
    serviceType() {
      if (this.value) {
        if (this.value.serviceType) {
          return this.value.serviceType;
        } else if (this.value.serviceTypeName) {
          return this.value.serviceTypeName;
        } else {
          return "ACCOMMODATION";
        }
      } else {
        return "ACCOMMODATION";
      }
    },
    title() {
      return this.value
        ? `${this.value.supplierName} - ${
            this.value.rateTypeCode
          } - ${this.$options.filters.formatDate(
            this.value.startDate
          )} - ${this.$options.filters.formatDate(this.value.endDate)}`
        : "Remarks";
    },
    subTitle() {
      return this.value
        ? `${this.value.qty} x ${
            this.value.isExtra ? this.value.boardBasis : this.value.serviceName
          }, Adults: ${this.value.adults}, Children: ${
            this.value.children
          }, Infants: ${this.value.infants}`
        : "Service:";
    },
    isValid() {
      return true;
    },
  },

  watch: {
    value(newVal) {
      this.remarks = { ...newVal.remarks };
    },
  },

  methods: {
    onSave() {
      this.$emit("save", { ...this.remarks });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/RemarksEditDialog.vue